module.exports = __webpack_public_path__ + "img/2x.04a6d98.jpg";